import api from '../api'
export default {
	namespaced: true,
	state: {
		staffList: [],
		staffTotal: ''
	},
	mutations: {
		GET_STAFF_LIST( state, data = {} ) {
			state.staffList = data.records
			state.staffTotal = data.total
		}
	},
	actions: {
		GET_STAFF_LIST( { commit, dispatch },  config ) {
			return api.getStaffList( config ).then(( res ) => {
				commit( 'GET_STAFF_LIST', res.payload )
				return res
			}).catch(( rej ) => {
				window.myVue.$message.error( rej.message )
			})
		},
		GET_STAFF_DETAIL ({ commit, dispatch }, config) {
			return api.staffDetail(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		DELETE_STAFF ({ commit, dispatch }, params) {
			return api.deletestaff({
				params: params
			}).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		ADD_STAFF ({ commit, dispatch }, config) {
			return api.addstaff(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		},
		UPDATE_STAFF ({ commit, dispatch }, config) {
			return api.updatestaff(config).then((res) => {
				return res
			}).catch((rej) => {
				window.myVue.$message.error(rej.message)
			})
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/staffManage/store/index.js